import styled from 'react-emotion'
import { color } from '../../../../../style'
import Button from '../../../../common/Button'

// Button with no border and indented to show nesting
export default styled(Button)({
  label: 'GlobalNavRow',
  color: color.black,
  border: 'none',
  background: 'white',
  position: 'relative', // ensures row is on top of folder lines,
  '&:hover': {
    background: 'white'
  }
})
